import Input from "./Input/Input";
import Date from "./Date/Date";
import Select from "./Select/Select";
import Search from "./Search/Search";
import Files from "./Files/Files";
import Images from "./Images/Images";
import Currency from "./Currency/Currency";
import CheckBox from "./CheckBox/CheckBox";
import Radio from "./Radio/Radio";
import JsonObjs from "./JsonObjs/JsonObjs";
import RichText from "./RichText/RichText";
import Text from "./Text/Text";
import TblSelect from "./TblSelect/TblSelect";
import Arrays from "./Arrays/Arrays";
import JsonTpl from "./JsonTpl/JsonTpl";
import ObjEdit from "./ObjEdit/ObjEdit";
import ArrEdit from "./ArrEdit/ArrEdit";
import { useForm } from "react-hook-form";
import SkidId from "./SkidId/SkidId";
// export const Input = Input;

export const widgets = {
    'calculable': Input,
    'input': Input,
    
    'checkbox': CheckBox,
    'checkboxes': CheckBox,
    'radio': Radio,

    'date': Date,
    'select': Select,
    'search': Search,
    'searchItems': Search,
    'files': Files,
    'attachment': Files,
    'images': Images,
    'currency': Currency,
    'jsonObjs': JsonObjs,
    'html': RichText,
    'text': Text,
    // 'text': Txt
    'tblSelect': TblSelect,
    'arrays': Arrays,
    'jsonTpl': JsonTpl,
    'objEdit': ObjEdit,
    'arrEdit': ArrEdit,
    'skidid': SkidId
};

export const getEditWgt= type=>{
    // return widgets[type||'input'];
    // [] usage: 2 ways:
    // 1. pass form in
    // 2. pass forms in, with formName, path, fldVal
    return function Wgt({fldName, form:formIn, fldDef, opts, fldVal, forms, path 
        ,objTpl //for jsonObj
    }){
        const formLocal = useForm();
        const form = formIn || formLocal;

        // [] if pass forms in
        if(path && forms){
            forms[path] = form;
        }

        // init form value
        if(form === formLocal && fldVal!==undefined){
        // if(fldVal!==undefined){
            console.log(`init Wgt init [${[path,fldName].filter(a=>a).join(',')}]`, form === formLocal);
            console.log('.................... init Wgt form value', path, fldName, fldVal);
            if(fldVal.constructor === String){
                // form.setValue([path,fldName].filter(a=>a).join(','), fldVal);
                form.setValue(path, fldVal);
            }else if(fldVal.constructor === Array){
                fldVal.forEach((itemVal, itemIdx)=>{
                    // form.setValue([path,fldName].filter(a=>a).join(','), itemVal);
                    form.setValue(path, itemVal);
                })
            }else{
                if(objTpl){
                    Object.keys(objTpl).forEach(attrName=>{
                        // form.setValue([path,fldName,attrName].filter(a=>a).join(','), fldVal[attrName]);
                        form.setValue(path, fldVal[attrName]);
                    })                           
                }
         
            }
        }
        // }

        const TrueWgt = widgets[type||'input'];

        return <TrueWgt
            // origin interface 
            fldName={fldName}
            form={form}
            fldDef={fldDef}
            opts={opts}

            // [] extended Wgt interface
            fldVal={fldVal}
            objVal={fldVal}
            
            forms={forms}
            path={path}

            // for ObjEdit
            objTpl={objTpl}
        ></TrueWgt>
    }

}

export const wgtSettings = {
    // 'calculable': Input,
    // 'input': Input,
    
    // 'checkbox': CheckBox,
    'checkboxes': {
        singleValue: {
            type: 'input',
            default: 'true'
        },
        src:{
            // type: 

        }
    },
    // 'radio': Radio,

    // 'date': Date,
    'search': {
        srcShowFlds:{

        },
        srcShowType:{
            default: 'list'
        },
        srcSearchFlds:{
            
        },
        srcTbl:{
            type: 'tblSelect'
        }
    },
    'select': {
        src:{
            type: 'arrays'
        }
    },
    // 'searchItems': Search,
    // 'files': Files,
    // 'attachment': Files,
    // 'images': Images,
    // 'currency': Currency,
    'jsonObjs': {
        objTpl: {
            type: 'jsonTpl'
        }
    },
    // 'html': RichText,
    // 'text': Text
}

// function extractContent(s) {
//     var span = document.createElement('span');
//     span.innerHTML = s;
//     return span.textContent || span.innerText;
// };

// export function getShowType(inputTypeName){
//     switch(inputTypeName){
//         case "attachment":
//             return function Files(props){
//                 let files;
//                 try{
//                     files = JSON.parse(props.rcd[props.fldName]);
//                 }catch(err){
//                     console.error(err);
//                     files = []
//                 }
//                 return <div className="row">
//                     {false&&files.map((fileDef,idx)=><div key={idx} className="card col-md-3">
//                         <a href={(fileDef.url||"").startsWith("data:")?fileDef.url:getUploadFileUrl(fileDef.url)}
//                             target="_blank"
//                         >{fileDef.url}</a>
//                         {/* {imgDef.url} */}
//                     </div>)}
//                     <ul className="ms-3">
//                     {files.map((fileDef,idx)=><li key={idx} className="">
//                         <a href={(fileDef.url||"").startsWith("data:")?fileDef.url:getUploadFileUrl(fileDef.url)}
//                             target="_blank"
//                         >{fileDef.url}</a>
//                         {/* {imgDef.url} */}
//                     </li>)}
//                     </ul>

//                 </div>;
//             }

//         case "images":
//             return function Imgs(props){
//                 const formCache = props.formCache || {};
//                 let imgs;
//                 try{
//                     imgs = JSON.parse(props.rcd[props.fldName]||"[]");
//                 }catch(err){
//                     console.error(err);
//                     imgs = []
//                 }
//                 return <div className="row">
//                     {imgs.map((imgDef,idx)=><ImgCard key={idx} 
//                         idx={idx}
//                         imgDef={imgDef}
//                         handleDelImage={_=>{}}
//                         formCache={formCache}
//                         btns={"show"}
//                     />)}
//                 </div>;
//             }

//         case "jsonObjs":
//             return function ShowJsonObjs(props){
//                 const objTpl = (props.settings||{}).objTpl || {};
//                 const inputSettings = objTpl.inputSettings || {};
//                 let json;
//                 try{
//                     json = JSON.parse(props.rcd[props.fldName]||"[]");
//                 }catch(err){
//                     console.error(err);
//                     json = undefined;
//                 }

//                 return <div className="row"
//                     style={{
//                         "maxHeight": "20em",
//                         "overflow":"scroll"
//                     }}
//                 >
//                     {json===undefined?<strong>json parse error.</strong>:
//                     json.length>0?<table>
//                         <thead>
//                             <tr className="row"><th className="col"
//                                 style={{"flex":"0"}}
//                             >#</th>{
//                                 Object.keys(json[0]).map((k2,idx2)=>
//                                     <th
//                                         className="col"
//                                         key={idx2}
//                                     >{k2}</th>
//                                 )
//                             }</tr>
//                         </thead>
//                         <tbody>
//                         {
//                             Object.keys(json).map((k,idx)=><tr
//                                 className="row"
//                                 key={idx}
//                             >
//                                 <td className="col"
//                                     style={{"flex":"0"}}
//                                 >{idx+1}</td>
//                                 {
//                                     Object.keys(json[k]).map((k2,idx2)=>
//                                         <td 
//                                             className="col"
//                                             key={idx2}
//                                         >
//                                             {/* {json[k][k2]} */}
//                                             {getShowType((inputSettings[k2]||{}).type)({
//                                                 rcd: json[k],
//                                                 fldName: k2,
//                                                 settings: inputSettings[k2]||{}
//                                             })}
//                                         </td>
//                                     )
//                                 }
//                             </tr>
//                             )
//                         }
//                         </tbody>
//                     </table>:""}
//                 </div>;
//             }
//         case "html":
//             return function Html(props){
//                 const val=String(props.rcd[props.fldName]||"");
//                 return <div>
//                     {extractContent(val).substring(0,40)} {val.length>40?"...":""}
//                 </div>
//             }
//         case "input":
//         case "text":
//         default:
//             return function Text(props){
//                 const val=String(props.rcd[props.fldName]||"");
//                 return <div>
//                     {val.substring(0,40)} {val.length>40?"...":""}
//                 </div>
//             }

//             // return function Str(props){
//             //     return <span>{props.rcd[props.fldName]}</span>;
//             // }    
//     }

// }

export default function getWidget(widgetName){
    return widgets[widgetName || 'input'];
};
